// src/Components/partners/PartnersHub.jsx
import React, { useState } from 'react';
import { Handshake, Clock, Users, BarChart3 } from 'lucide-react';
import PendingApplicationsTab from './PendingApplicationsTab';
import ActivePartnersTab from './ActivePartnersTab';
import PartnerAnalyticsTab from './PartnerAnalyticsTab';

const TABS = [
  { id: 'pending',   label: 'Pending Applications', icon: Clock,     Component: PendingApplicationsTab },
  { id: 'active',    label: 'Active Partners',       icon: Users,     Component: ActivePartnersTab },
  { id: 'analytics', label: 'Partnership Analytics', icon: BarChart3, Component: PartnerAnalyticsTab },
];

export default function PartnersHub() {
  const [activeTab, setActiveTab] = useState('pending');
  const ActiveComponent = TABS.find((t) => t.id === activeTab)?.Component || PendingApplicationsTab;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 flex items-center gap-2">
          <Handshake className="text-red-600" size={24} />
          Partners
        </h1>
        <p className="text-sm text-gray-500">Review applications, manage active partners, and track performance</p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow">
        <div className="border-b border-gray-100 dark:border-gray-700 overflow-x-auto">
          <div className="flex min-w-max px-2">
            {TABS.map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => setActiveTab(id)}
                className={`flex items-center gap-2 px-4 py-3.5 text-sm font-medium transition border-b-2 whitespace-nowrap ${
                  activeTab === id
                    ? 'text-red-600 border-red-600'
                    : 'text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200'
                }`}
              >
                <Icon size={15} /> {label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <ActiveComponent />
    </div>
  );
}